import { render } from "./LabelMaterialsButton.vue?vue&type=template&id=6f7d543e&scoped=true&ts=true"
import script from "./LabelMaterialsButton.vue?vue&type=script&lang=ts"
export * from "./LabelMaterialsButton.vue?vue&type=script&lang=ts"

import "./LabelMaterialsButton.vue?vue&type=style&index=0&id=6f7d543e&scoped=true&lang=css"

import exportComponent from "/home3/sli/web/public/resources/editorvue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f7d543e"]])

export default __exports__